/**
 * ACTOR TYPES
 *
 * Types for identifying who performed an action (created_by, updated_by fields).
 * An actor can be a team member, a role, the system (automated actions), or a
 * user (actions performed via the external-facing API).
 */

export const HUMAN_ACTOR_TYPE_VALUES = ["team_member", "role"] as const;

export type HumanActorType = (typeof HUMAN_ACTOR_TYPE_VALUES)[number];

export const ACTOR_TYPE_VALUES = ["team_member", "role", "system", "user"] as const;

export type ActorType = (typeof ACTOR_TYPE_VALUES)[number];

export type Actor = {
  id: string;
  type: ActorType;
};
